import { OptionsIcon } from '@assets/icons';
import { Group } from '@components/layout';
import { useTheme } from '@mui/material';
import { MouseEventHandler } from 'react';

export const BreadcrumbActionMenuButton = ({ onClick }: { onClick: MouseEventHandler }) => {
  const { palette } = useTheme();
  return (
    <Group
      onClick={onClick}
      sx={{
        cursor: 'pointer',
        alignItems: 'center',
        '&:hover .deckard-icon': { color: palette.menu.item.hoverText },
      }}
    >
      <OptionsIcon size={16} />
    </Group>
  );
};
